import { createContext } from 'react';

/**
 * Track de música de la librería del cliente, tal como lo consume el editor.
 * El consumer (Brands, Social, etc.) le da forma equivalente desde su backend.
 */
export type MusicTrack = {
  /** ID estable del track, para referenciarlo desde la clip de audio. */
  id: string;
  /** Nombre legible para mostrar en la UI del sound panel. */
  name: string;
  /** URL pública del archivo (CDN), lista para reproducir. */
  url: string;
  /** Duración en ms si el consumer la conoce. */
  durationMs?: number;
};

/**
 * Servicios externos que el sound panel necesita para funcionar.
 * El editor es agnóstico al transporte (HTTP, IPC, mock, etc.); el consumer
 * provee las implementaciones reales vía <AudioServicesProvider value={...}>.
 */
export type AudioServicesValue = {
  /**
   * Genera audio TTS a partir de un script y devuelve la URL del archivo.
   * Si falla, devuelve null (el panel muestra el error correspondiente).
   */
  generateVoiceover: (script: string) => Promise<{ audioUrl: string; audioId: string } | null>;

  /**
   * Lista los tracks de música disponibles para el cliente actual.
   * Si falla, devuelve null.
   */
  loadMusicTracks: () => Promise<MusicTrack[] | null>;
};

export const AudioServicesContext = createContext<AudioServicesValue | null>(null);
